import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Edit, Cross } from '../../helpers/icon-dictionary';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import Button from '../../components/button/index';
import messages from './messages';
import withModal from '../with-modal';
import productEnum from '../../helpers/product-enum';

const ClassEditGroup = (props) => {
    const {
        icon,
        handleOnCloseModal,
        handleOnManageStudents,
        handleOnChangeCourse,
        intl,
        isDefaultGroup,
        classTitle,
        selectedGroup,
        courseName,
        handleOnShowRenameGroupModal,
        isDeletingGroupInProgress,
        handleOnDeleteGroupRequest,
        selectedProduct,
        upfCourseName,
        newCourseName
    } = props;

    const { classroomId: selectedClassroomId, id: selectedGroupId } = selectedGroup;
    const isMatletica = productEnum.MATLETICA.id === selectedProduct.id;
    const isMathletics = productEnum.MATHLETICS.id === selectedProduct.id;

    const buttonSet = (isDefaultGroup) ?
        (<div className={css.buttonGroup}>
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={`renameGroupBtn ${css.buttonWrapper}`}
                handleOnClick={handleOnShowRenameGroupModal}
                icon={Edit}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.renameGroup)} />
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={`manageStudentBtn ${css.buttonWrapper}`}
                handleOnClick={() => handleOnManageStudents(selectedGroup.classroomId, classTitle, selectedGroupId)}
                icon={Edit}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.manageStudents)} />
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={`changeCourseBtn ${css.buttonWrapper}`}
                handleOnClick={() => { handleOnChangeCourse(selectedClassroomId, selectedGroupId); }}
                hidden={isMatletica}
                icon={Edit}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.changeCourse)} />
        </div>) :
        (<div className={css.buttonGroup}>
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={`renameGroupBtn ${css.buttonWrapper}`}
                handleOnClick={handleOnShowRenameGroupModal}
                icon={Edit}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.renameGroup)} />
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={`manageStudentBtn ${css.buttonWrapper}`}
                handleOnClick={() => handleOnManageStudents(selectedGroup.classroomId, classTitle, selectedGroupId)}
                icon={Edit}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.manageStudents)} />
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={`changeCourseBtn ${css.buttonWrapper}`}
                handleOnClick={() => { handleOnChangeCourse(selectedClassroomId, selectedGroupId); }}
                hidden={isMatletica}
                icon={Edit}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.changeCourse)} />
            <Button
                buttonContainer={css.buttonContainer}
                buttonContainerDisabled={css.buttonContainerDisabled}
                containerClassName={`${css.buttonWrapper} ${css.buttonDelete} deleteGroupBtn`}
                disabled={isDeletingGroupInProgress}
                handleOnClick={handleOnDeleteGroupRequest}
                icon={Cross}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.delete)}
                loadingLabel={intl.formatMessage(messages.deleting)} />
        </div>);
    return (<div className={css.classConfirmationContainer}>
        <div className={css.icon}>
            <SvgIcon icon={icon} />
        </div>
        <div className={css.title}>
            {classTitle} | <span className={css.selectedGroup}>{selectedGroup.name}</span>
            <div>
                <span className={css.titleSub}>{isMatletica ? '' : courseName}</span>
                {isMathletics && upfCourseName && (<span className={css.titleSub}>, {newCourseName}</span>)}
                {isMathletics && upfCourseName && (<div className={css.titleSub}> & {upfCourseName}</div>)}
            </div>
        </div>
        {buttonSet}
        <Button
            buttonContainer={css.buttonContainer}
            containerClassName={css.buttonClose}
            handleOnClick={handleOnCloseModal}
            icon={Cross}
            iconClassName={css.buttonIcon} />
    </div>);
};

ClassEditGroup.propTypes = {
    classTitle: PropTypes.string,
    courseName: PropTypes.string,
    handleOnChangeCourse: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnDeleteGroupRequest: PropTypes.func,
    handleOnManageStudents: PropTypes.func,
    handleOnShowRenameGroupModal: PropTypes.func,
    icon: PropTypes.string,
    intl: intlShape.isRequired,
    isDefaultGroup: PropTypes.bool,
    isDeletingGroupInProgress: PropTypes.bool,
    selectedGroup: PropTypes.object,
    selectedProduct: PropTypes.object,
    upfCourseName: PropTypes.string,
    newCourseName: PropTypes.string
};

const IntlClassEditGroup = injectIntl(ClassEditGroup);
export default withModal('isActive')(IntlClassEditGroup);



// WEBPACK FOOTER //
// ./app/components/edit-class-group/index.js